import { render, staticRenderFns } from "./About.vue?vue&type=template&id=7cfb5af1&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=7cfb5af1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb5af1",
  null
  
)

/* custom blocks */
import block0 from "./About.vue?vue&type=custom&index=0&blockType=meta&name=viewport&content=width%3Ddevice-width%2C%20initial-scale%3D1.0"
if (typeof block0 === 'function') block0(component)

export default component.exports